import React, { Suspense, useEffect } from "react";
import ProfileMenuList from "../components/Profile/ProfileMenuList";
import SupportSection from "../components/Profile/SupportSection";
import ContactSection from "../components/ContactSection/ContactSection";


import styles from "./Profile.module.css";

const ProfileHeader = React.lazy(() =>
  import("../components/Profile/ProfileHeader")
);

const Profile: React.FC = () => {

  useEffect(() => {
    document.body.classList.add("profile-page-safe-area-extend");
  
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      document.body.classList.add("is-ios");
    }
  
    return () => {
      document.body.classList.remove("profile-page-safe-area-extend");
      document.body.classList.remove("is-ios");
    };
  }, []);
  

  
  return (
  
      <div className={styles.pageContainer}>
        <Suspense
          fallback={
            <div className={styles.spinnerContainer}>
              <div className={styles.spinner}></div>
            </div>
          }
        >
          <ProfileHeader />
        </Suspense>

        <ProfileMenuList />

        <SupportSection profile={undefined} />

        <ContactSection />
      </div>
 
  );
};

export default Profile;
